import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import axios from "axios";
import PieChart from "../PieChartNew";
import { scrollToSection } from "../helpers/links";

const ExpensesMonthChart = ({ expensesPath, month, useMonth }) => {
  const [data, setData] = useState(null);

  const fetchData = () => {
    let url = `${expensesPath}.json?kind=current_month`;
    url = useMonth ? `${url}&month=${month}` : url;
    axios
      .get(url, {
        headers: ReactOnRails.authenticityHeaders({}),
      })
      .then((response) => {
        const { data } = response.data;
        setData(data);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, [month]);

  useEffect(() => {
    scrollToSection("pie_mont_expenses_chart");
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <div
      className="px-2 flex flex-col items-center justify-center mt-4"
      id="pie_mont_expenses_chart"
    >
      <div className="max-w-xl w-full">
        <PieChart
          data={data}
          showExpectedData={true}
          sliceNumber={6}
          title={
            useMonth ? "Monthly expenses by category" : "Expenses by category"
          }
        />
      </div>
    </div>
  );
};

ExpensesMonthChart.propTypes = {
  expensesPath: PropTypes.string.isRequired,
  month: PropTypes.string,
  useMonth: PropTypes.bool,
};

export default ExpensesMonthChart;
